export const urgencies = [
  { id: 3, name: "Alta" },
  { id: 2, name: "Media" },
  { id: 1, name: "Baja" },
];
